export enum BRAND {
    FAIRVIEW = 'Fairview',
    NEXT = 'Next',
    EUROWOOD = 'Eurowood',
    VETRO_RACCORDI = 'VetroRaccordi',
    LIDAR = 'Lidar',
}

export const BRAND_OPTIONS = [
    { name: 'Fairview', id: BRAND.FAIRVIEW },
    { name: 'Next', id: BRAND.NEXT },
    { name: 'Eurowood', id: BRAND.EUROWOOD },
    { name: 'Vetro Raccordi', id: BRAND.VETRO_RACCORDI },
    { name: 'Lidar', id: BRAND.LIDAR },
];

export const BRAND_FILTER_OPTIONS = [
    { name: 'All Brands', id: 'ALL_BRANDS' },
    ...BRAND_OPTIONS,
];
